import { useIsInOfficeQuery } from '../services/skudApi';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StaffOnline = ({ staffId, variant = 'filled' }) => {
  const { t } = useTranslation('translations');
  const { data: isInOffice, isLoading } = useIsInOfficeQuery({ staffId });

  if (isLoading) return null;

  return (
    <Chip
      label={isInOffice ? t('InOffice') : t('NotInOffice')}
      color={isInOffice ? 'success' : 'error'}
      variant={variant}
    />
  );
};

export default StaffOnline;
